module.exports = __webpack_public_path__ + "img/folder-grid.7ce2a1cd.svg";